const ErrorPage = () => <div> Error page </div>

export default ErrorPage
